module.exports = __webpack_public_path__ + "img/9-sdg-full@2x.de7b0bac.png";